import React from 'react'
import backArrow from '../../../../assets/icons/arrow-left.svg'

const RestaurantFormAvailability = props => {
	const {
		configData,
		restaurantTimes,
		restaurantVenueId,
		handleBackToSearch,
		handleClose,
		activeReservationTime,
		handleActiveReservationTime,
		handleSetActiveRestaurant
	} = props

	const hotelLabels = configData.hotel.labels[0]
	let renderTimeOptions = []

	for (const time in restaurantTimes) {
		const currentTime = restaurantTimes[time]
		let currentType = 'request'

		if (currentTime.type) {
			currentType = currentTime.type
		}

		renderTimeOptions.push(
			<button
				key={ 'restaurant-time-' + restaurantVenueId + time }
				className={ activeReservationTime === currentTime.time  ? 'btn btn-transparent active' : 'btn btn-transparent' }
				onClick={ activeReservationTime === currentTime.time ?
					() => handleActiveReservationTime(null)
				:
					() => handleActiveReservationTime(currentTime.time, currentType)
				}
			>
				{ currentTime.time }
			</button>
		)
	}

	return (
		<div className="bk-flow-restaurants__form-availability">
			<h5>
				<button
					className="bk-flow-restaurants__form-availability-back btn btn-text-only"
					onClick={ handleBackToSearch }
				>
					<img src={ backArrow } alt="Back to Reservation Search" />
					{ hotelLabels && hotelLabels.back ? hotelLabels.back : 'Back'}
				</button>

				{
					hotelLabels &&
					hotelLabels.diningAvailableTimes ? (
						hotelLabels.diningAvailableTimes
					) : (
						'Availability'
					)
				}

				<button
					className="btn btn-text-only"
					onClick={ handleClose }
				>
					<i className="material-icons">close</i>
				</button>
			</h5>

			<div className="bk-flow-restaurants__form-availability-times">
				{ renderTimeOptions }
			</div>

			<div className="bk-flow-restaurants__form-buttons">
				<button
					className="btn btn-transparent"
					onClick={ handleSetActiveRestaurant }
					disabled={ !activeReservationTime }
				>
					{
						hotelLabels &&
						hotelLabels.diningAddReservation ? (
							hotelLabels.diningAddReservation
						) : (
							'Add to Hotel Reservation'
						)
					}
				</button>
			</div>
		</div>
	)
}

export default RestaurantFormAvailability



// WEBPACK FOOTER //
// ./src/components/forms/restaurantForm/elements/RestaurantFormAvailability.js